import icon from "~/components/ui/icons/svg/spinner.svg";
import { cn } from "~/lib/ui";

export const Spinner = ({ className = "" }) => {
  return (
    <div className="popup">
      <svg
        aria-hidden="true"
        role="status"
        className={cn(
          "fill-accent mr-2 inline h-4 w-4 animate-spin text-gray-800",
          className,
        )}
        viewBox="0 0 100 101"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <use xlinkHref={`#${icon}`} />
      </svg>
    </div>
  );
};
